import React, { useState } from "react";
import {
  db,
  addDoc,
  collection,
} from "../../firebase/firebase";
import signupVideo from '../../assets/img/2k.mp4'
import styles from "./signup.module.css"; 
import Header from "../../components/header/header/header";
import { auth } from "../../firebase/firebase";
import { useNavigate } from "react-router";
import { createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
const GetStarted = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [address, setAddress] = useState("");
  const [reason, setReason] = useState("");
  const [city, setCity] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [subscribeEmail, setSubscribeEmail] = useState(false);
  const [referralSources, setReferralSources] = useState({
    search: false,
    social: false,
    friend: false,
    event: false,
    other: false
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    if (!name || !email || !role || !address || !agreeToTerms || !phoneNumber) {
      setShowError(true);
      setErrorMessage("Veuillez remplir tous les champs obligatoires !");
      setLoading(false);
      return;
    }
  
    try {
      // Generate a random temporary password (user won't know this)
      const tempPassword = Math.random().toString(36).slice(-12);
      
      // Create user with temporary password
      const userCredential = await createUserWithEmailAndPassword(auth, email, tempPassword);
      const user = userCredential.user;
  
      const candidateData = {
        uid: user.uid,
        email: email,
        name: name,
        phoneNumber: phoneNumber,
        role: role,
        address: address,
        reason: reason,
        city: city,
        agreeToTerms: agreeToTerms,
        subscribeEmail: subscribeEmail,
        referralSources: referralSources,
        emailSent: 0,
        createdAt: new Date(),
        status: 'pending',
        passwordSet: false
      };
  
      await addDoc(collection(db, "candidates"), candidateData);
  
     
  
      setShowSuccess(true);
    } catch (error) {
      /*console.error("Error during registration:", error);*/
      setShowError(true);
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReferralChange = (source) => {
    setReferralSources({
      ...referralSources,
      [source]: !referralSources[source]
    });
  };

  const resetForm = () => {
    setEmail('');
    setName('');
    setPhoneNumber('');
    setRole('');
    setReason('');
    setCity('');
    setAddress('');
    setError('');
    setAgreeToTerms(false);
    setSubscribeEmail(false);
    setReferralSources({
      search: false,
      social: false,
      friend: false,
      event: false,
      other: false
    });
  };

  return (
    <div>
      <Header/>
      <main>
      {showSuccess && (
          <div className={styles.successPopup}>
            <div className={styles.popupContent}>
              <h2>Demande enregistrée avec succès !</h2>
              <button 
                onClick={() => {
                  setShowSuccess(false);
                  navigate('/');
                }} 
                className={styles.closeButton}
              >
                Fermer
              </button>
            </div>
          </div>
        )}

        {showError && (
          <div className={styles.errorPopup}>
            <div className={styles.popupContent}>
              <p>{errorMessage}</p>
              <button 
                onClick={() => setShowError(false)} 
                className={styles.closeButton}
              >
                Fermer
              </button>
            </div>
          </div>
        )}
        <div className={styles.signupContainer}>
          <div className={styles.imageSection}>
            <video 
              autoPlay 
              loop 
              playsInline
              muted 
              className={styles.signupVideo}
            >
              <source src={signupVideo} type="video/mp4" />
                Votre navigateur ne prend pas en charge les vidéos HTML5.
            </video>
          </div>
          <div className={styles.formSection}>
            <h1 className={styles.heading}>Rejoignez-nous !</h1>
            <p className={`${styles.subtitle} ${styles.description}`}>
              Rejoignez l'aventure Diamond en fournissant les informations suivantes
            </p>

            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.formGroup}>
                <input
                  type="text"
                  id="name"
                  placeholder=" "
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <label className={`${styles.label} ${styles.nameLabel}`} >
                  Nom et prénom <span className={styles.required}>*</span>
                </label>
              </div>

              <div className={styles.formGroup}>
                <input
                  type="email"
                  id="email"
                  placeholder=" "
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                />
                <label className={styles.label} htmlFor="email">
                  Email <span className={styles.required}>*</span>
                </label>
              </div>
                <div className={styles.formGroup}>
                <input
                  type="tel"
                  id="phoneNumber"
                  placeholder=" "
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <label className={styles.label} htmlFor="phoneNumber">
                  Numéro de téléphone <span className={styles.required}>*</span>
                </label>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.roleLabel}>
                  Vous êtes <span className={styles.required}>*</span>
                </label>
                <div className={styles.radioGroup}>
                  <label className={styles.radioLabel}>
                    <input type="radio" name="role" value="dentiste omnipraticien" onChange={(e) => setRole(e.target.value)} />
                    Dentiste omnipraticien
                  </label>
                  <label className={styles.radioLabel}>
                    <input type="radio" name="role" value="orthodontiste" onChange={(e) => setRole(e.target.value)} />
                    Orthodontiste
                  </label>
                </div>
              </div>

              <div className={styles.formGroup}>
                <input
                  type="text"
                  id="address"
                  value={address}
                  onChange={e => setAddress(e.target.value)}
                  placeholder=" "
                  className={styles.input}
                  required
                />
              <label className={styles.label} htmlFor="address">Adresse <span className={styles.required}>*</span></label>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.roleLabel}>J'ai rejoint Diamond pour:</label>
                <select id="reason" value={reason} onChange={(e) => setReason(e.target.value)} >
                  <option value="">Sélectionnez</option>
                  <option value="info">Savoir plus sur les services et produits de Diamond</option>
                  <option value="contact">Être contacté par un représentant</option>
                </select>
              </div>

              <div className={styles.formGroup}>
                <label className={`${styles.checkboxLabel} ${styles.terms}`}>
                  <input type="checkbox" checked={agreeToTerms} onChange={(e) => setAgreeToTerms(e.target.checked)} />
                  En cochant cette case et en cliquant sur « Soumettre », j'accepte que mes données personnelles soient traitées conformément 
                  à la Politique en matière de confidentialité.
                </label>
              </div>

              <div className={styles.formGroup}>
                <label className={`${styles.checkboxLabel} ${styles.terms}`}>
                  <input type="checkbox" checked={subscribeEmail} onChange={(e) => setSubscribeEmail(e.target.checked)} />
                  En cochant cette case et en cliquant sur « Soumettre », j'accepte de recevoir des communications électroniques de Diamond® contenant des informations sur le traitement Diamond®, les produits et services, les enquêtes, 
                  ainsi que d'autres informations que nous jugeons pertinentes pour vous.
                </label>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.roleLabel}>Comment avez-vous connu notre site ?</label>
                <div className={styles.checkboxGroup}>
                  <label className={styles.checkboxLabel}>
                    <input 
                      type="checkbox" 
                      checked={referralSources.search} 
                      onChange={() => handleReferralChange('search')} 
                    />
                    Par des amis ou connaissances
                  </label>
                  <label className={styles.checkboxLabel}>
                    <input 
                      type="checkbox" 
                      checked={referralSources.social} 
                      onChange={() => handleReferralChange('social')} 
                    />
                    Sur Facebook
                  </label>
                  <label className={styles.checkboxLabel}>
                    <input 
                      type="checkbox" 
                      checked={referralSources.friend} 
                      onChange={() => handleReferralChange('friend')} 
                    />
                    Par e-mail / newsletter
                  </label>
                  <label className={styles.checkboxLabel}>
                    <input 
                      type="checkbox" 
                      checked={referralSources.other} 
                      onChange={() => handleReferralChange('other')} 
                    />
                    Autre
                  </label>
                </div>
              </div>
              
              <button type="submit" className={`${styles.submitBtn} ${styles.cta}`}>
              Rejoignez nous
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default GetStarted;